var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3334,
    y: 7.32056,
    width: 5.1139,
    height: 1.12506,
    rx: 0.562529,
    transform: "rotate(180 11.3334 7.32056)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 3.94541C11.3334 4.25608 11.0815 4.50793 10.7708 4.50793H6.78201C6.47133 4.50793 6.21948 4.25608 6.21948 3.94541V3.94541C6.21948 3.63473 6.47133 3.38288 6.782 3.38288H10.7708C11.0815 3.38288 11.3334 3.63473 11.3334 3.94541V3.94541Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 1.13266C11.3334 1.44334 11.0815 1.69519 10.7708 1.69519H6.78201C6.47133 1.69519 6.21948 1.44334 6.21948 1.13266V1.13266C6.21948 0.821985 6.47133 0.570132 6.782 0.570132H10.7708C11.0815 0.570132 11.3334 0.821985 11.3334 1.13266V1.13266Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31417 0.702762C3.40782 0.614233 3.52488 0.569968 3.65364 0.569968C3.7707 0.569968 3.89946 0.614233 3.99311 0.702762C4.1804 0.87982 4.1804 1.16754 3.99311 1.3446L1.24225 3.94514L3.99311 6.54568C4.1804 6.72274 4.1804 7.01046 3.99311 7.18752C3.80582 7.36458 3.50147 7.36458 3.31417 7.18752L0.223844 4.26606C0.130197 4.17753 0.083374 4.06687 0.083374 3.94514C0.083374 3.82341 0.130197 3.71275 0.223844 3.62422L3.31417 0.702762Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.2c4719d1fcc23cf98e6c7f3ebdee48f2.svg";
export { ForwardRef as ReactComponent };